// extracted by mini-css-extract-plugin
export default {"search_wrapper":"SearchBar_search_wrapper__RDeta","clearButton":"SearchBar_clearButton__h4Ff2"};